var _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _mask, _g8, _path2, _g9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailSyncIcon = function SvgEmailSyncIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 62 71"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M22.54 5.458c3.072-1.977 4.608-2.965 6.26-3.35a9.8 9.8 0 0 1 4.443 0c1.653.385 3.19 1.373 6.261 3.35l7.302 4.698c2.628 1.69 3.942 2.536 4.894 3.668a9.8 9.8 0 0 1 1.863 3.414C54 18.652 54 20.214 54 23.34v16.87c0 5.488 0 8.231-1.068 10.327a9.8 9.8 0 0 1-4.282 4.282c-2.096 1.068-4.84 1.068-10.326 1.068H23.72c-5.487 0-8.23 0-10.326-1.068a9.8 9.8 0 0 1-4.282-4.282c-1.068-2.096-1.068-4.84-1.068-10.327V23.34c0-3.125 0-4.687.437-6.1a9.8 9.8 0 0 1 1.863-3.415c.952-1.132 2.266-1.977 4.894-3.668z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillOpacity: 0.55,
    d: "M22.54 5.458c3.072-1.977 4.608-2.965 6.26-3.35a9.8 9.8 0 0 1 4.443 0c1.653.385 3.19 1.373 6.261 3.35l7.302 4.698c2.628 1.69 3.942 2.536 4.894 3.668a9.8 9.8 0 0 1 1.863 3.414C54 18.652 54 20.214 54 23.34v16.87c0 5.488 0 8.231-1.068 10.327a9.8 9.8 0 0 1-4.282 4.282c-2.096 1.068-4.84 1.068-10.326 1.068H23.72c-5.487 0-8.23 0-10.326-1.068a9.8 9.8 0 0 1-4.282-4.282c-1.068-2.096-1.068-4.84-1.068-10.327V23.34c0-3.125 0-4.687.437-6.1a9.8 9.8 0 0 1 1.863-3.415c.952-1.132 2.266-1.977 4.894-3.668z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillOpacity: 0.55,
    d: "M22.54 5.458c3.072-1.977 4.608-2.965 6.26-3.35a9.8 9.8 0 0 1 4.443 0c1.653.385 3.19 1.373 6.261 3.35l7.302 4.698c2.628 1.69 3.942 2.536 4.894 3.668a9.8 9.8 0 0 1 1.863 3.414C54 18.652 54 20.214 54 23.34v16.87c0 5.488 0 8.231-1.068 10.327a9.8 9.8 0 0 1-4.282 4.282c-2.096 1.068-4.84 1.068-10.326 1.068H23.72c-5.487 0-8.23 0-10.326-1.068a9.8 9.8 0 0 1-4.282-4.282c-1.068-2.096-1.068-4.84-1.068-10.327V23.34c0-3.125 0-4.687.437-6.1a9.8 9.8 0 0 1 1.863-3.415c.952-1.132 2.266-1.977 4.894-3.668z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillOpacity: 0.55,
    d: "M22.54 5.458c3.072-1.977 4.608-2.965 6.26-3.35a9.8 9.8 0 0 1 4.443 0c1.653.385 3.19 1.373 6.261 3.35l7.302 4.698c2.628 1.69 3.942 2.536 4.894 3.668a9.8 9.8 0 0 1 1.863 3.414C54 18.652 54 20.214 54 23.34v16.87c0 5.488 0 8.231-1.068 10.327a9.8 9.8 0 0 1-4.282 4.282c-2.096 1.068-4.84 1.068-10.326 1.068H23.72c-5.487 0-8.23 0-10.326-1.068a9.8 9.8 0 0 1-4.282-4.282c-1.068-2.096-1.068-4.84-1.068-10.327V23.34c0-3.125 0-4.687.437-6.1a9.8 9.8 0 0 1 1.863-3.415c.952-1.132 2.266-1.977 4.894-3.668z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#g)",
    strokeWidth: 0.233,
    d: "M28.827 2.222a9.7 9.7 0 0 1 4.39 0c1.628.379 3.145 1.352 6.224 3.334l7.302 4.698c2.634 1.695 3.93 2.53 4.868 3.645a9.7 9.7 0 0 1 1.841 3.374c.43 1.392.432 2.934.432 6.066V40.21c0 2.745-.001 4.797-.134 6.425-.133 1.626-.398 2.82-.922 3.848a9.7 9.7 0 0 1-4.23 4.23c-1.03.525-2.222.79-3.849.923s-3.68.133-6.426.133H23.721c-2.746 0-4.798 0-6.426-.133-1.627-.133-2.82-.398-3.849-.922a9.68 9.68 0 0 1-4.23-4.23c-.524-1.03-.79-2.223-.922-3.85-.133-1.627-.134-3.679-.134-6.424V23.339c0-3.132.001-4.674.432-6.066a9.7 9.7 0 0 1 1.84-3.374c.939-1.115 2.235-1.95 4.869-3.645l7.301-4.698c3.08-1.982 4.597-2.955 6.225-3.334Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 41,
    x: 13,
    y: 13,
    fill: "#FCFDFF",
    rx: 2.557
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#819D9B",
    strokeLinecap: "round",
    d: "M23.5 19.5h15"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#819D9B",
    strokeLinecap: "round",
    d: "M23.5 23.5h15"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#819D9B",
    strokeLinecap: "round",
    d: "M23.5 27.5h15"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 25.344,
    height: 40.724,
    x: 7.3,
    y: 16.457
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.35px)",
      clipPath: "url(#l)",
      height: "100%",
      width: "100%"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 0.7,
    filter: "url(#m)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.022 39.696.922-.924c-1.114 1.46-2.79 3.14-5.2 5.55l-9.798 9.798q-.761.762-1.432 1.429a8 8 0 0 1-2.037-.692 10.03 10.03 0 0 1-4.383-4.384C8 48.328 8 45.52 8 39.901V26.044c0-4.273.002-6.92.482-8.887z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    fillOpacity: 0.7,
    d: "m31.022 39.696.922-.924c-1.114 1.46-2.79 3.14-5.2 5.55l-9.798 9.798q-.761.762-1.432 1.429a8 8 0 0 1-2.037-.692 10.03 10.03 0 0 1-4.383-4.384C8 48.328 8 45.52 8 39.901V26.044c0-4.273.002-6.92.482-8.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "m31.022 39.696-.165.165.165.165.165-.165zm.922-.924.186.142-.35-.307zm-5.2 5.55-.165-.166zm-9.798 9.798.165.165zm-1.432 1.429-.048.228.123.026.089-.089zm-2.037-.692-.105.208zm-4.383-4.384-.208.106zM8 39.901h.233zm0-13.857h-.233zm.482-8.887.165-.165-.293-.293-.098.403zm22.54 22.54.165.164.922-.924-.165-.165-.165-.165-.923.924zm.922-.925-.185-.141c-1.102 1.444-2.766 3.111-5.18 5.525l.165.165.165.165c2.405-2.405 4.095-4.098 5.22-5.572zm-5.2 5.55-.165-.166-9.798 9.799.165.165.165.165 9.798-9.799zm-9.798 9.798-.165-.165q-.761.762-1.432 1.428l.165.166.164.165q.672-.666 1.433-1.43zm-1.432 1.429.047-.229a7.8 7.8 0 0 1-1.978-.67l-.106.207-.105.208c.63.321 1.313.55 2.094.712zm-2.037-.692.106-.208a9.8 9.8 0 0 1-4.281-4.282l-.208.106-.208.106a10.27 10.27 0 0 0 4.486 4.486zm-4.383-4.384.208-.105c-.527-1.035-.797-2.24-.933-3.898-.135-1.66-.136-3.756-.136-6.569h-.466c0 2.805 0 4.923.137 6.607.138 1.687.416 2.96.982 4.071zM8 39.901h.233V26.044h-.466V39.9zm0-13.857h.233c0-4.286.003-6.899.476-8.832l-.227-.055-.226-.055c-.49 2-.49 4.683-.49 8.942zm.482-8.887-.165.165 22.54 22.54.165-.166.164-.165L8.647 16.992z",
    mask: "url(#p)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 25.341,
    height: 40.725,
    x: 29.359,
    y: 16.454
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.35px)",
      clipPath: "url(#q)",
      height: "100%",
      width: "100%"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 0.7,
    filter: "url(#r)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.978 39.694-.92-.92c1.115 1.458 2.79 3.138 5.198 5.545l9.798 9.799q.761.762 1.432 1.429a8 8 0 0 0 2.037-.692 10.03 10.03 0 0 0 4.383-4.384C54 48.326 54 45.517 54 39.9V26.042c0-4.273-.001-6.92-.482-8.888z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    fillOpacity: 0.7,
    d: "m30.978 39.694-.92-.92c1.115 1.458 2.79 3.138 5.198 5.545l9.798 9.799q.761.762 1.432 1.429a8 8 0 0 0 2.037-.692 10.03 10.03 0 0 0 4.383-4.384C54 48.326 54 45.517 54 39.9V26.042c0-4.273-.001-6.92-.482-8.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "m30.978 39.694.164.165-.165.165-.165-.165zm-.92-.92-.185.142.35-.307zm5.198 5.545.165-.165zm9.798 9.799-.165.165zm1.432 1.429.048.228-.123.026-.089-.089zm2.037-.692.105.208zm4.383-4.384.208.106zM54 39.9h-.233zm0-13.857h.233zm-.482-8.888-.165-.165.293-.293.098.403zm-22.54 22.54-.166.165-.918-.92.165-.165.165-.165.919.92zm-.92-.92.186-.142c1.102 1.443 2.765 3.11 5.177 5.522l-.165.165-.165.165c-2.403-2.403-4.092-4.095-5.218-5.568zm5.198 5.545.165-.165 9.798 9.799-.165.165-.165.165-9.798-9.799zm9.798 9.799.165-.165q.761.761 1.432 1.428l-.165.166-.164.165q-.671-.666-1.433-1.43zm1.432 1.429-.047-.229a7.8 7.8 0 0 0 1.978-.67l.105.207.106.208c-.63.321-1.313.55-2.094.712zm2.037-.692-.106-.208a9.8 9.8 0 0 0 4.281-4.282l.208.106.208.106a10.27 10.27 0 0 1-4.486 4.486zm4.383-4.384-.208-.105c.527-1.035.797-2.24.933-3.898.135-1.66.136-3.756.136-6.569h.466c0 2.805 0 4.923-.137 6.607-.138 1.687-.416 2.96-.982 4.071zM54 39.9h-.233V26.042h.466v13.857zm0-13.857h-.233c0-4.287-.003-6.9-.476-8.833l.227-.055.226-.055c.49 2 .49 4.683.49 8.943zm-.482-8.888.164.165-22.54 22.54-.165-.165-.164-.165 22.54-22.54z",
    mask: "url(#u)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "y",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.922 30.439a10.03 10.03 0 0 1 6.2 0c2.29.744 4.276 2.73 8.249 6.703l9.798 9.798q.761.76 1.426 1.43c-.159.766-.378 1.43-.688 2.038a10.03 10.03 0 0 1-4.384 4.384c-2.146 1.094-4.955 1.094-10.572 1.094H24.093c-5.617 0-8.426 0-10.572-1.094a10.03 10.03 0 0 1-4.384-4.384c-.31-.609-.53-1.272-.69-2.038q.667-.67 1.428-1.43l9.798-9.798c3.973-3.973 5.959-5.959 8.25-6.703"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M27.922 30.439a10.03 10.03 0 0 1 6.2 0c2.29.744 4.276 2.73 8.249 6.703l9.798 9.798q.761.76 1.426 1.43c-.159.766-.378 1.43-.688 2.038a10.03 10.03 0 0 1-4.384 4.384c-2.146 1.094-4.955 1.094-10.572 1.094H24.093c-5.617 0-8.426 0-10.572-1.094a10.03 10.03 0 0 1-4.384-4.384c-.31-.609-.53-1.272-.69-2.038q.667-.67 1.428-1.43l9.798-9.798c3.973-3.973 5.959-5.959 8.25-6.703"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "m27.922 30.439-.072-.222zm6.2 0 .072-.222zm8.249 6.703-.165.165zm9.798 9.798.165-.165zm1.426 1.43.229.048.025-.123-.088-.089zm-.688 2.038.208.106zm-4.384 4.384.106.208zM37.95 55.886v.233zm-13.858 0v.233zM13.52 54.792l-.106.208zm-4.384-4.384-.208.106zm-.69-2.038-.165-.164-.088.09.025.122zm1.428-1.43-.165-.165zm9.798-9.798.165.165zm8.25-6.703.071.222a9.8 9.8 0 0 1 6.056 0l.072-.222.072-.222a10.27 10.27 0 0 0-6.344 0zm6.199 0-.072.222c1.104.358 2.146 1.02 3.414 2.097 1.27 1.078 2.753 2.56 4.742 4.549l.165-.165.165-.165c-1.984-1.983-3.481-3.481-4.77-4.575-1.29-1.096-2.386-1.8-3.572-2.185zm8.249 6.703-.165.165 9.798 9.798.165-.165.165-.165-9.799-9.798zm9.798 9.798-.164.165q.759.76 1.425 1.43l.165-.165.166-.164-1.427-1.431zm1.426 1.43-.228-.047c-.156.75-.369 1.392-.668 1.98l.208.105.208.106c.321-.631.546-1.315.709-2.096zm-.688 2.038-.208-.105a9.8 9.8 0 0 1-4.282 4.281l.106.208.106.208a10.27 10.27 0 0 0 4.486-4.486zm-4.384 4.384-.106-.208c-1.035.527-2.239.797-3.897.933-1.661.136-3.757.136-6.57.136v.466c2.806 0 4.923 0 6.608-.137 1.687-.138 2.96-.416 4.07-.982zM37.95 55.886v-.233H24.093v.466h13.858zm-13.858 0v-.233c-2.812 0-4.908 0-6.569-.136-1.658-.136-2.863-.406-3.897-.933l-.106.208-.106.208c1.111.566 2.384.844 4.071.982 1.685.137 3.802.137 6.607.137zM13.52 54.792l.106-.208a9.8 9.8 0 0 1-4.282-4.281l-.208.105-.208.106A10.27 10.27 0 0 0 13.415 55zm-4.384-4.384.208-.105c-.3-.588-.513-1.23-.669-1.98l-.228.047-.229.048c.163.781.389 1.465.71 2.096zm-.69-2.038.166.165q.666-.67 1.427-1.43l-.165-.165-.165-.165q-.761.76-1.428 1.431zm1.428-1.43.165.165 9.798-9.798-.165-.165-.165-.165-9.798 9.798zm9.798-9.798.165.165c1.99-1.99 3.471-3.47 4.742-4.55 1.268-1.076 2.31-1.738 3.414-2.096l-.072-.222-.072-.222c-1.186.385-2.282 1.09-3.572 2.185-1.289 1.094-2.786 2.591-4.77 4.575z",
    mask: "url(#y)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 50.28,
    height: 31.07,
    x: 5.882,
    y: 27.382
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.28px)",
      clipPath: "url(#z)",
      height: "100%",
      width: "100%"
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.566,
    filter: "url(#A)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.922 30.439a10.03 10.03 0 0 1 6.2 0c2.29.744 4.276 2.73 8.249 6.703l9.798 9.798q.761.76 1.426 1.43c-.159.766-.378 1.43-.688 2.04a10.03 10.03 0 0 1-4.383 4.383c-2.146 1.094-4.956 1.093-10.573 1.093H24.094c-5.617 0-8.427 0-10.573-1.093a10.03 10.03 0 0 1-4.383-4.383c-.31-.61-.531-1.274-.69-2.04q.666-.67 1.427-1.43l9.798-9.798c3.973-3.973 5.959-5.959 8.25-6.703"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    fillOpacity: 0.2,
    d: "M27.922 30.439a10.03 10.03 0 0 1 6.2 0c2.29.744 4.276 2.73 8.249 6.703l9.798 9.798q.761.76 1.426 1.43c-.159.766-.378 1.43-.688 2.04a10.03 10.03 0 0 1-4.383 4.383c-2.146 1.094-4.956 1.093-10.573 1.093H24.094c-5.617 0-8.427 0-10.573-1.093a10.03 10.03 0 0 1-4.383-4.383c-.31-.61-.531-1.274-.69-2.04q.666-.67 1.427-1.43l9.798-9.798c3.973-3.973 5.959-5.959 8.25-6.703"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "m27.922 30.439-.072-.222zm6.2 0 .072-.222zm8.249 6.703-.165.165zm9.798 9.798.165-.165zm1.426 1.43.229.047.025-.123-.088-.089zm-.688 2.04.208.105zm-4.383 4.383.106.208zM37.95 55.886v-.233zm-24.43-1.093-.106.208zM9.138 50.41l-.208.105zm-.69-2.04-.166-.165-.088.09.025.122zm1.427-1.43-.165-.165zm9.798-9.798.165.165zm8.25-6.703.071.222a9.8 9.8 0 0 1 6.056 0l.072-.222.072-.222a10.27 10.27 0 0 0-6.344 0zm6.199 0-.072.222c1.104.358 2.146 1.02 3.414 2.097 1.27 1.078 2.753 2.56 4.742 4.549l.165-.165.165-.165c-1.984-1.983-3.481-3.481-4.77-4.575-1.29-1.096-2.386-1.8-3.572-2.185zm8.249 6.703-.165.165 9.798 9.798.165-.165.165-.165-9.799-9.798zm9.798 9.798-.164.165q.76.76 1.425 1.429l.165-.165.166-.164-1.427-1.43zm1.426 1.43-.228-.048c-.156.75-.369 1.394-.668 1.982l.208.105.208.106c.322-.632.546-1.316.709-2.098zm-.688 2.04-.208-.106a9.8 9.8 0 0 1-4.281 4.281l.106.208.106.208a10.27 10.27 0 0 0 4.485-4.486zm-4.383 4.383-.106-.208c-1.034.527-2.24.797-3.898.932-1.66.136-3.757.136-6.57.136v.466c2.806 0 4.924 0 6.608-.137 1.688-.138 2.96-.415 4.072-.98zM37.95 55.886v-.233H24.094v.466h13.857zm-13.857 0v-.233c-2.812 0-4.908 0-6.57-.136-1.658-.135-2.863-.405-3.897-.932l-.106.208-.106.208c1.111.566 2.384.843 4.072.981 1.684.138 3.802.137 6.607.137zM13.52 54.793l.106-.208a9.8 9.8 0 0 1-4.281-4.281l-.208.105-.208.106a10.27 10.27 0 0 0 4.485 4.486zM9.138 50.41l.208-.106c-.3-.588-.514-1.232-.67-1.982l-.228.047-.229.048c.163.782.39 1.467.711 2.098zm-.69-2.04.165.164q.666-.67 1.427-1.43l-.165-.164-.165-.165q-.761.76-1.428 1.43zm1.427-1.43.165.165 9.798-9.798-.165-.165-.165-.165-9.798 9.798zm9.798-9.798.165.165c1.99-1.99 3.471-3.47 4.742-4.55 1.268-1.076 2.31-1.738 3.414-2.096l-.072-.222-.072-.222c-1.186.385-2.282 1.09-3.572 2.185-1.289 1.094-2.786 2.591-4.77 4.575z",
    mask: "url(#D)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 30.903,
    x2: 30.903,
    y1: 8.233,
    y2: 80.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7ECF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#E7ECF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#4F7962",
    stopOpacity: 0.596
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 10.377,
    x2: 48.984,
    y1: 23.46,
    y2: 47.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 6.302,
    x2: 30.748,
    y1: 24.862,
    y2: 35.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7ECF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#E7ECF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#4F7962"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 19.972,
    x2: 19.972,
    y1: 23.265,
    y2: 71.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 55.698,
    x2: 31.253,
    y1: 24.859,
    y2: 35.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7ECF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#4F7962"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 42.029,
    x2: 42.029,
    y1: 23.262,
    y2: 71.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 30.905,
    x2: 30.905,
    y1: 29.992,
    y2: 69.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7ECF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#E7ECF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#878F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 31.021,
    x2: 31.021,
    y1: 34.074,
    y2: 66.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 30.905,
    x2: 30.905,
    y1: 29.992,
    y2: 69.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7ECF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#E7ECF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#4F7962"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 31.021,
    x2: 31.021,
    y1: 34.074,
    y2: 66.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 62,
    height: 70.033,
    x: 0,
    y: 0.853,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.25098 0 0 0 0 0.415686 0 0 0 0 0.407843 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5284_6229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5284_6229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 45.956,
    height: 55.666,
    x: 8.044,
    y: 1.853,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.633
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5284_6229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: 47.156,
    height: 53.318,
    x: 7.422,
    y: 0.682,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 4.648,
    result: "effect1_dropShadow_5284_6229"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -6.74
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.113
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.309804 0 0 0 0 0.47451 0 0 0 0 0.384314 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5284_6229"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 11.621,
    result: "effect2_dropShadow_5284_6229"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -13.712
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.557
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.542397 0 0 0 0 0.728009 0 0 0 0 0.626364 0 0 0 0.47 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_5284_6229",
    result: "effect2_dropShadow_5284_6229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5284_6229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    width: 16,
    height: 2,
    x: 23,
    y: 19,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5284_6229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5284_6229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    width: 16,
    height: 2,
    x: 23,
    y: 23,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5284_6229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5284_6229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    width: 16,
    height: 2,
    x: 23,
    y: 27,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5284_6229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5284_6229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    width: 25.344,
    height: 40.724,
    x: 7.3,
    y: 16.457,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.633
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5284_6229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "r",
    width: 25.341,
    height: 40.725,
    x: 29.359,
    y: 16.454,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.633
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5284_6229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "v",
    width: 45.148,
    height: 27.571,
    x: 8.448,
    y: 29.948,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.633
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5284_6229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "A",
    width: 50.28,
    height: 31.07,
    x: 5.882,
    y: 27.382,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.633
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5284_6229"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-34.8753 13.6902 -9.24027 -25.3958 33.121 33.957)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F7962",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#6B7080",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-19.24563 13.41346 -56.44582 -80.98847 55.75 11.096)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F7962",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#4F7962",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(14.81327 3.84918 -16.1979 62.33629 10.96 14.596)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838487",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l",
    transform: "translate(-7.3 -16.457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.022 39.696.922-.924c-1.114 1.46-2.79 3.14-5.2 5.55l-9.798 9.798q-.761.762-1.432 1.429a8 8 0 0 1-2.037-.692 10.03 10.03 0 0 1-4.383-4.384C8 48.328 8 45.52 8 39.901V26.044c0-4.273.002-6.92.482-8.887z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q",
    transform: "translate(-29.359 -16.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.978 39.694-.92-.92c1.115 1.458 2.79 3.138 5.198 5.545l9.798 9.799q.761.762 1.432 1.429a8 8 0 0 0 2.037-.692 10.03 10.03 0 0 0 4.383-4.384C54 48.326 54 45.517 54 39.9V26.042c0-4.273-.001-6.92-.482-8.888z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z",
    transform: "translate(-5.882 -27.382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.922 30.439a10.03 10.03 0 0 1 6.2 0c2.29.744 4.276 2.73 8.249 6.703l9.798 9.798q.761.76 1.426 1.43c-.159.766-.378 1.43-.688 2.04a10.03 10.03 0 0 1-4.383 4.383c-2.146 1.094-4.956 1.093-10.573 1.093H24.094c-5.617 0-8.427 0-10.573-1.093a10.03 10.03 0 0 1-4.383-4.383c-.31-.61-.531-1.274-.69-2.04q.666-.67 1.427-1.43l9.798-9.798c3.973-3.973 5.959-5.959 8.25-6.703"
  })))));
};
export default SvgEmailSyncIcon;